(function () {
  'use strict';

  var isMobile = window.matchMedia('(max-width: 767px)').matches;

  function startYoutube(el) {
    el.setAttribute('autoplay', '');
    if (typeof el.play === 'function') {
      el.play();
    }
  }

  function deferDesktopYoutube(el) {
    var delay = parseInt(el.getAttribute('data-snr-youtube-defer'), 10) || 2500;

    function run() {
      startYoutube(el);
    }

    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () {
        setTimeout(run, delay);
      }, { timeout: delay + 3000 });
    } else {
      window.addEventListener(
        'load',
        function () {
          setTimeout(run, delay);
        },
        { once: true }
      );
    }
  }

  function getYoutubeId(videoEl) {
    var iframe = videoEl.querySelector('iframe');
    if (iframe && iframe.src) {
      var match = iframe.src.match(/embed\/([^?&/]+)/);
      if (match) return match[1];
    }

    var tpl = videoEl.querySelector('template iframe');
    if (tpl) {
      var src = tpl.getAttribute('src') || tpl.src;
      var tplMatch = src && src.match(/embed\/([^?&/]+)/);
      if (tplMatch) return tplMatch[1];
    }

    return null;
  }

  function ensureMobileFacade(hero) {
    if (!isMobile || hero.querySelector('.snr-youtube-facade, .snr-mobile-hero-poster')) {
      return;
    }

    var videoEl = hero.querySelector('video-element[source="youtube"]');
    if (!videoEl) return;

    var youtubeId = hero.querySelector('[data-youtube-id]')?.dataset.youtubeId || getYoutubeId(videoEl);
    if (!youtubeId) return;

    var parallax = hero.querySelector('parallax-element') || hero;
    var facade = document.createElement('div');
    facade.className =
      'md:hidden block media mb:media--adapt media--adapt snr-mobile-hero-poster snr-youtube-facade snr-youtube-facade--js';
    facade.dataset.youtubeId = youtubeId;
    facade.innerHTML =
      '<div class="media-wrapper">' +
      '<img src="https://i.ytimg.com/vi/' +
      youtubeId +
      '/hqdefault.jpg" loading="eager" fetchpriority="high" sizes="100vw" width="480" height="360" alt="Video" class="snr-lcp-hero">' +
      '<button type="button" class="snr-youtube-facade__play media__play-button absolute flex items-center justify-center rounded-full pointer-events-auto z-10 motion-reduce" aria-label="Play video">' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="34" height="34"><path d="M6.3 4.2a1 1 0 0 1 1.5-.86l7.4 4.27a1 1 0 0 1 0 1.72l-7.4 4.27a1 1 0 0 1-1.5-.86V4.2Z"/></svg>' +
      '</button></div>' +
      '<div class="snr-youtube-facade__player hidden"></div>';

    var playerWrap = facade.querySelector('.snr-youtube-facade__player');
    playerWrap.appendChild(videoEl.cloneNode(true));
    parallax.appendChild(facade);
  }

  function boot() {
    document.querySelectorAll('.video-hero').forEach(ensureMobileFacade);

    document.querySelectorAll('video-element[source="youtube"][data-snr-youtube-defer]').forEach(deferDesktopYoutube);

    document.querySelectorAll('.snr-youtube-facade__play').forEach(function (button) {
      button.addEventListener('click', function () {
        var facade = button.closest('.snr-youtube-facade');
        if (!facade || facade.classList.contains('is-playing')) return;

        var playerWrap = facade.querySelector('.snr-youtube-facade__player');
        var videoEl = playerWrap && playerWrap.querySelector('video-element[source="youtube"]');
        if (!videoEl && facade.classList.contains('snr-youtube-facade--js')) {
          videoEl = document.createElement('video-element');
          videoEl.setAttribute('source', 'youtube');
          videoEl.className = 'media-wrapper';
          var tpl = document.createElement('template');
          tpl.innerHTML =
            '<iframe src="https://www.youtube.com/embed/' +
            facade.dataset.youtubeId +
            '?playsinline=1&controls=1&autoplay=1&mute=1&loop=1&playlist=' +
            facade.dataset.youtubeId +
            '&enablejsapi=1&rel=0&modestbranding=1&origin=' +
            encodeURIComponent(window.location.origin) +
            '" allow="autoplay; encrypted-media" allowfullscreen="allowfullscreen"></iframe>';
          videoEl.appendChild(tpl);
          playerWrap.appendChild(videoEl);
        }

        if (!videoEl) return;

        facade.classList.add('is-playing');
        playerWrap.classList.remove('hidden');
        startYoutube(videoEl);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
